// todo: move to using verge3d module.js
/* eslint-disable */
// need to disable linter or compile fails, need to move to module import
import { pGlob, pPhysics } from './vergeGlobals.js'

// ######## Init ########
// global variables/constants used by puzzles' functions
let params = v3d.AppUtils.getPageParams()
// copy globals from vergeGlobals lib
// need to use stringify copying via destructuring
let _pGlob = JSON.parse(JSON.stringify(pGlob))
let _pPhysics = JSON.parse(JSON.stringify(pPhysics))
// create initial app instance
let appInstance = null

// ######## Methods ########
// pass app instance to library
function passInstance(app) {
  appInstance = app
}
// reset global variables when removing app instance
// without this a new instance will start to use old cached objects
function resetGlobals() {
  _pGlob = JSON.parse(JSON.stringify(pGlob))
  _pPhysics = JSON.parse(JSON.stringify(pPhysics))
}

// utility function envoked by almost all V3D-specific puzzles
// filter off some non-mesh types
function notIgnoredObj(obj) {
  return (
    obj.type !== 'AmbientLight' &&
    obj.name !== '' &&
    !(obj.isMesh && obj.isMaterialGeneratedMesh)
  )
}

// utility function envoked by almost all V3D-specific puzzles
// find first occurence of the object by its name
function getObjectByName(objName) {
  var objFound
  var runTime = _pGlob !== undefined
  objFound = runTime ? _pGlob.objCache[objName] : null

  if (objFound && objFound.name === objName) return objFound

  appInstance.scene.traverse(function(obj) {
    if (!objFound && notIgnoredObj(obj) && obj.name == objName) {
      objFound = obj
      if (runTime) {
        _pGlob.objCache[objName] = objFound
      }
    }
  })
  return objFound
}

// utility function envoked by almost all V3D-specific puzzles
// retrieve all objects on the scene
function getAllObjectNames() {
  var objNameList = []
  appInstance.scene.traverse(function(obj) {
    if (notIgnoredObj(obj)) objNameList.push(obj.name)
  })
  return objNameList
}

// utility function envoked by almost all V3D-specific puzzles
// retrieve all objects which belong to the group
function getObjectNamesByGroupName(targetGroupName) {
  var objNameList = []
  appInstance.scene.traverse(function(obj) {
    if (notIgnoredObj(obj)) {
      var groupNames = obj.groupNames
      if (!groupNames) return
      for (var i = 0; i < groupNames.length; i++) {
        var groupName = groupNames[i]
        if (groupName == targetGroupName) {
          objNameList.push(obj.name)
        }
      }
    }
  })
  return objNameList
}

function getGroupNames() {
  let allGroupNames = []
  appInstance.scene.traverse(function(obj) {
    if (notIgnoredObj(obj)) {
      let groupNames = obj.groupNames
      if (!groupNames) return
      groupNames.every(el => {
        if (!allGroupNames.includes(el)) {
          allGroupNames.push(el)
        }
      })
    }
  })
  return allGroupNames
}

// utility function envoked by almost all V3D-specific puzzles
// process object input, which can be either single obj or array of objects, or a group
function retrieveObjectNames(objNames) {
  var acc = []
  retrieveObjectNamesAcc(objNames, acc)
  return acc
}

function retrieveObjectNamesAcc(currObjNames, acc) {
  if (typeof currObjNames == 'string') {
    acc.push(currObjNames)
  } else if (Array.isArray(currObjNames) && currObjNames[0] == 'GROUP') {
    var newObj = getObjectNamesByGroupName(currObjNames[1])
    for (var i = 0; i < newObj.length; i++) acc.push(newObj[i])
  } else if (Array.isArray(currObjNames) && currObjNames[0] == 'ALL_OBJECTS') {
    var newObj = getAllObjectNames()
    for (var i = 0; i < newObj.length; i++) acc.push(newObj[i])
  } else if (Array.isArray(currObjNames)) {
    for (var i = 0; i < currObjNames.length; i++)
      retrieveObjectNamesAcc(currObjNames[i], acc)
  }
}

/**
 * Retrieve coordinate system from the loaded scene
 */
function getCoordSystem() {
  var scene = appInstance.scene

  if (scene && 'v3d' in scene.userData && 'coordSystem' in scene.userData.v3d) {
    return scene.userData.v3d.coordSystem
  } else {
    // COMPAT: <2.17, consider replacing to 'Y_UP_RIGHT' for scenes with unknown origin
    return 'Z_UP_RIGHT'
  }
}

/**
 * Transform coordinates from one space to another
 * Can be used with Vector3 or Euler.
 */
function coordsTransform(coords, from, to, noSignChange) {
  if (from == to) return coords

  var y = coords.y,
    z = coords.z

  if (from == 'Z_UP_RIGHT' && to == 'Y_UP_RIGHT') {
    coords.y = z
    coords.z = noSignChange ? y : -y
  } else if (from == 'Y_UP_RIGHT' && to == 'Z_UP_RIGHT') {
    coords.y = noSignChange ? z : -z
    coords.z = y
  } else {
    console.error('coordsTransform: Unsupported coordinate space')
  }

  return coords
}

/**
 * Verge3D euler rotation to Blender/Max shortest.
 * 1) Convert from intrinsic rotation (v3d) to extrinsic XYZ (Blender/Max default
 *    order) via reversion: XYZ -> ZYX
 * 2) swizzle ZYX->YZX
 * 3) choose the shortest rotation to resemble Blender's behavior
 */
var eulerV3DToBlenderShortest = (function() {
  var eulerTmp = new v3d.Euler()
  var eulerTmp2 = new v3d.Euler()
  var vec3Tmp = new v3d.Vector3()

  return function(euler, dest) {
    var eulerBlender = eulerTmp.copy(euler).reorder('YZX')
    var eulerBlenderAlt = eulerTmp2.copy(eulerBlender).makeAlternative()

    var len = eulerBlender.toVector3(vec3Tmp).lengthSq()
    var lenAlt = eulerBlenderAlt.toVector3(vec3Tmp).lengthSq()

    dest.copy(len < lenAlt ? eulerBlender : eulerBlenderAlt)
    return coordsTransform(dest, 'Y_UP_RIGHT', 'Z_UP_RIGHT')
  }
})()

// tweenCamera puzzle
function tweenCamera(posOrObj, targetOrObj, duration, doSlot, movementType) {
  if (Array.isArray(posOrObj)) {
    var worldPos = _pGlob.vec3Tmp.fromArray(posOrObj)
    worldPos = coordsTransform(worldPos, getCoordSystem(), 'Y_UP_RIGHT')
  } else if (posOrObj) {
    var posObj = getObjectByName(posOrObj)
    if (!posObj) return
    var worldPos = posObj.getWorldPosition(_pGlob.vec3Tmp)
  } else {
    // empty input means: don't change the position
    var worldPos = appInstance.camera.getWorldPosition(_pGlob.vec3Tmp)
  }

  if (Array.isArray(targetOrObj)) {
    var worldTarget = _pGlob.vec3Tmp2.fromArray(targetOrObj)
    worldTarget = coordsTransform(worldTarget, getCoordSystem(), 'Y_UP_RIGHT')
  } else {
    var targObj = getObjectByName(targetOrObj)
    if (!targObj) return
    var worldTarget = targObj.getWorldPosition(_pGlob.vec3Tmp2)
  }

  duration = Math.max(0, duration)

  if (appInstance.controls && appInstance.controls.tween) {
    // orbit and flying cameras
    if (!appInstance.controls.inTween) {
      appInstance.controls.tween(
        worldPos,
        worldTarget,
        duration,
        doSlot,
        movementType
      )
    }
  } else {
    // TODO: static camera, just position it for now
    if (appInstance.camera.parent) {
      appInstance.camera.parent.worldToLocal(worldPos)
    }
    appInstance.camera.position.copy(worldPos)
    appInstance.camera.lookAt(worldTarget)
    doSlot()
  }
}

/************
 * Animations
 ***********/

/**
 * Get a scene that contains the root of the given action.
 */
function getSceneByAction(action) {
  var root = action.getRoot()
  var scene = root.type == 'Scene' ? root : null
  root.traverseAncestors(function(ancObj) {
    if (ancObj.type == 'Scene') {
      scene = ancObj
    }
  })
  return scene
}

/**
 * Get the current scene's framerate.
 */
function getSceneAnimFrameRate(scene) {
  if (
    scene &&
    'v3d' in scene.userData &&
    'animFrameRate' in scene.userData.v3d
  ) {
    return scene.userData.v3d.animFrameRate
  }
  return 24
}

var initAnimationMixer = (function() {
  function onMixerFinished(e) {
    var cb = _pGlob.animMixerCallbacks
    var found = []
    for (var i = 0; i < cb.length; i++) {
      if (cb[i][0] == e.action) {
        cb[i][0] = null // desactivate
        found.push(cb[i][1])
      }
    }
    for (var i = 0; i < found.length; i++) {
      found[i]()
    }
  }

  return function initAnimationMixer() {
    if (
      appInstance.mixer &&
      !appInstance.mixer.hasEventListener('finished', onMixerFinished)
    )
      appInstance.mixer.addEventListener('finished', onMixerFinished)
  }
})()

// animation puzzles
function operateAnimation(
  operation,
  animations,
  from,
  to,
  loop,
  speed,
  callback,
  isPlayAnimCompat,
  rev
) {
  if (!animations) return
  // input can be either single obj or array of objects
  if (typeof animations == 'string') animations = [animations]

  function processAnimation(animName) {
    var action = v3d.SceneUtils.getAnimationActionByName(appInstance, animName)
    if (!action) return
    switch (operation) {
      case 'PLAY':
        if (!action.isRunning()) {
          action.reset()
          if (loop && loop != 'AUTO') action.loop = v3d[loop]
          var scene = getSceneByAction(action)
          var frameRate = getSceneAnimFrameRate(scene)

          // compatibility reasons: deprecated playAnimation puzzles don't
          // change repetitions
          if (!isPlayAnimCompat) {
            action.repetitions = Infinity
          }

          var timeScale = Math.abs(parseFloat(speed))
          if (rev) timeScale *= -1

          action.timeScale = timeScale
          action.timeStart = from !== null ? from / frameRate : 0
          if (to !== null) {
            action.getClip().duration = to / frameRate
          } else {
            action.getClip().resetDuration()
          }
          action.time =
            timeScale >= 0 ? action.timeStart : action.getClip().duration

          action.paused = false
          action.play()

          // push unique callbacks only
          var callbacks = _pGlob.animMixerCallbacks
          var found = false

          for (var j = 0; j < callbacks.length; j++)
            if (callbacks[j][0] == action && callbacks[j][1] == callback)
              found = true

          if (!found) _pGlob.animMixerCallbacks.push([action, callback])
        }
        break
      case 'STOP':
        action.stop()

        // remove callbacks
        var callbacks = _pGlob.animMixerCallbacks
        for (var j = 0; j < callbacks.length; j++)
          if (callbacks[j][0] == action) {
            callbacks.splice(j, 1)
            j--
          }

        break
      case 'PAUSE':
        action.paused = true
        break
      case 'RESUME':
        action.paused = false
        break
      case 'SET_FRAME':
        var scene = getSceneByAction(action)
        var frameRate = getSceneAnimFrameRate(scene)
        action.time = from ? from / frameRate : 0
        action.play()
        action.paused = true
        break
    }
  }

  for (var i = 0; i < animations.length; i++) {
    var animName = animations[i]
    if (animName) processAnimation(animName)
  }

  initAnimationMixer()
}
// getAnimations puzzle
function getAnimations(objNames) {
  objNames = retrieveObjectNames(objNames)
  if (!objNames) return
  var animations = []
  for (var i = 0; i < objNames.length; i++) {
    var objName = objNames[i]
    if (!objName) continue
    // use objName as animName - for now we have one-to-one match
    var action = v3d.SceneUtils.getAnimationActionByName(appInstance, objName)
    if (action) animations.push(objName)
  }
  return animations
}

function registerSetTimeout(timeout, callback) {
  window.setTimeout(callback, 1000 * timeout)
}

// setActiveCamera puzzle
function setActiveCamera(camName) {
  var camera = getObjectByName(camName)
  if (!camera || !camera.isCamera || appInstance.camera == camera) return
  appInstance.setCamera(camera)
}

// addAnnotation and removeAnnotation puzzles
function handleAnnot(add, annot, objNames, contents, id) {
  objNames = retrieveObjectNames(objNames)
  if (!objNames) return
  for (var i = 0; i < objNames.length; i++) {
    var objName = objNames[i]
    if (!objName) continue
    var obj = getObjectByName(objName)
    if (!obj) continue
    // check if it already has an annotation and remove it
    for (var j = 0; j < obj.children.length; j++) {
      var child = obj.children[j]
      if (child.type == 'Annotation') {
        obj.remove(child)
        appInstance.container.removeChild(child.annotation)
      }
    }
    if (add) {
      var aObj = new v3d.Annotation(appInstance.container, annot, contents)
      aObj.name = annot
      aObj.fadeObscured = _pGlob.fadeAnnotations
      if (id) {
        aObj.annotation.id = id
        aObj.annotationDialog.id = id + '_dialog'
      }
      obj.add(aObj)
    }
  }
}

export {
  passInstance,
  notIgnoredObj,
  getObjectByName,
  getAllObjectNames,
  getObjectNamesByGroupName,
  getGroupNames,
  retrieveObjectNames,
  retrieveObjectNamesAcc,
  getCoordSystem,
  coordsTransform,
  tweenCamera,
  getSceneByAction,
  getSceneAnimFrameRate,
  operateAnimation,
  getAnimations,
  registerSetTimeout,
  setActiveCamera,
  handleAnnot,
  resetGlobals
}
